import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Actions } from 'src/components/CustomTable/components/Actions'
import { montaTypes } from 'src/constants/montaType'
import ROUTES from 'src/constants/routes'
import { CoverageProcessDto } from 'src/dto/coverage-process.dto'
import { formatDate } from 'src/utils'

export const useRegisterCoupleTableHeader = () => {
  const navigate = useNavigate()

  const tableHeader = [
    {
      property: 'nomeVaca',
      name: 'NOME VACA',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      property: 'nomeTouro',
      name: 'NOME TOURO',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      property: 'tipoMonta',
      name: 'REPRODUÇÃO',
      format: (value: string) => (value ? montaTypes[value]?.value ?? '-' : '-'),
      textAlign: 'center'
    },
    {
      property: 'dataInicio',
      name: 'DATA COBERTURA',
      format: (value: string) => formatDate(value, false) || '-',
      textAlign: 'center'
    },
    {
      property: 'inseminador',
      name: 'Inseminador',
      format: (value: string) => value || '-',
      textAlign: 'center'
    },
    {
      size: 122,
      property: 'status',
      compoment: (value: CoverageProcessDto) => (
        <Actions onClick={() => navigate(`${ROUTES.REPRODUCTION.COVERAGE_PROCESS.ROOT}/${value.id}`)} />
      )
    }
  ]

  return {
    tableHeader
  }
}
